(function () {
  if (window.__pcSliderInit) return;
  window.__pcSliderInit = true;

  function findTrack(el) {
    var figure = el.closest('.product-card__figure');
    return figure ? figure.querySelector('.pc-slider__track') : null;
  }

  function getIndex(track) {
    var first = track.children[0];
    if (!first) return 0;
    var w = first.getBoundingClientRect().width || first.offsetWidth;
    return w ? Math.round(track.scrollLeft / w) : 0;
  }

  function setDots(figure, idx) {
    var dots = figure.querySelectorAll('.pc-slider__dot');
    for (var k = 0; k < dots.length; k++) {
      if (k === idx) dots[k].classList.add('is-active');
      else dots[k].classList.remove('is-active');
    }
  }

  function goTo(track, idx, instant) {
    var first = track.children[0];
    if (!first) return;
    var total = track.children.length;
    idx = ((idx % total) + total) % total;
    var w = first.getBoundingClientRect().width || first.offsetWidth;
    if (instant) {
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = idx * w;
      track.style.scrollBehavior = prev;
    } else {
      track.scrollTo({ left: idx * w, behavior: 'smooth' });
    }
  }

  function handle(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.pc-slider__arrow--prev, .pc-slider__arrow--next, .pc-slider__dot');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (e.type !== 'click') return;
    var figure = btn.closest('.product-card__figure');
    var track = figure && figure.querySelector('.pc-slider__track');
    if (!track) return;
    var total = track.children.length;
    var cur = getIndex(track);
    var target = cur;
    if (btn.classList.contains('pc-slider__arrow--prev')) target = cur - 1;
    else if (btn.classList.contains('pc-slider__arrow--next')) target = cur + 1;
    else target = parseInt(btn.getAttribute('data-pc-dot'), 10) || 0;
    target = ((target % total) + total) % total;
    var instant = (cur === 0 && target === total - 1) || (cur === total - 1 && target === 0);
    goTo(track, target, instant);
    setDots(figure, target);
  }

  document.addEventListener('click', handle, true);
  document.addEventListener('mousedown', handle, true);
  document.addEventListener('touchstart', handle, true);

  function attach(track) {
    if (track.__pcAttached) return;
    track.__pcAttached = true;
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var figure = track.closest('.product-card__figure');
        if (figure) setDots(figure, getIndex(track));
      }, 60);
    });
  }

  function scan() {
    var tracks = document.querySelectorAll('.pc-slider__track');
    for (var i = 0; i < tracks.length; i++) attach(tracks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  if ('MutationObserver' in window) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
})();
